export default {"src":"/_next/static/media/campaigns-vouchers.b19261e4.svg","height":18,"width":32,"blurWidth":0,"blurHeight":0};